<template>
    <v-card>
        <v-card-title> {{ $t("Ulkoasuasetukset") }} </v-card-title>

        <v-card-text>
            <v-tabs v-model="tab" outline>
                <v-tabs-slider></v-tabs-slider>
                <v-tab>{{ $t("Logo") }}</v-tab>
                <v-tab>{{ $t("Väri") }}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <div class="pa-4 mt-4">
                        <tenant-logo />
                    </div>
                </v-tab-item>
                <v-tab-item>
                    <div class="pa-4 mt-4">
                        <tenant-color />
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </v-card-text>
    </v-card>
</template>

<script>
import { ref } from "@vue/composition-api";
import TenantLogo from "./components/tenant-logo.vue";
import TenantColor from "./components/tenant-color.vue";

export default {
    components: {
        TenantLogo,
        TenantColor,
    },
    setup() {
        const tab = ref(null);
        return { tab };
    },
};
</script>

<style></style>
